import React, {useState} from "react";
import styles from "./processCompareSidebarRename/ProcessCompareSidebarRename.module.scss";
import Button from "../../../../Componnets/Button/Button";

const ProcessCompareSidebarRename = ({ info = {layer_number: null, layer_name: null}, handleCloseStep, handleRename }) => {

  const [layerNum, setLayerNum] = useState(info.layer_number);
  const [layerName, setLayerName] = useState(info.layer_name);

  const handleSave = () => {
    handleRename({layer_name: layerName, layer_number: layerNum, layer: info.layer, id: info.id});
    handleCloseStep();
  }

  return (
    <div className={styles.ProcessCompareSidebarRename}>
      <div>
        <input onChange={(e) => setLayerNum(e.target.value)} value={layerNum} type={'text'} />
      </div>
      <div className={'mt-3'}>
        <input onChange={(e) => setLayerName(e.target.value)} value={layerName} type={'text'} />
      </div>
      <div className={'mt-4'}>
        <Button
          title={'Save'}
          type={'primary'}
          size={'block'}
          height={'medium'}
          onClick={handleSave}
        />
      </div>
    </div>
  )
}

export default ProcessCompareSidebarRename;